const chatbotTemplates = {
  appareilRefHtml: `
    <div class="options-container">
      <img
        src="{productPict}"
        alt="Appareil"
        style="max-width:100px;max-height:200px;border-radius:8px;margin-right:10px;object-fit:cover;"
        onerror="this.style.display='none'"
      />
      <div>
        <strong>{productName}</strong><br />
        <strong>Marque :</strong> {productBrand}<br />
        <strong>Modèle :</strong> {productModel}
      </div>
      <button data-option="bon-produit">Oui, c'est celui-ci </button>
      <button data-option="modifier-appareil">Non, modifier l'appareil</button>
    </div>
  `,
  appareilConfirmHtml: `
    <div class="options-container">
      <img
        src="{productPict}"
        alt="Appareil"
        style="max-width:100px;max-height:200px;border-radius:8px;margin-right:10px;object-fit:cover;"
        onerror="this.style.display='none'"
      />
      <div>
        <strong>{productName}</strong><br />
        <strong>Marque :</strong> {productBrand}<br />
        <strong>Modèle :</strong> {productModel}
        <div class="options-container" style="margin-top:10px;">
          <button data-option="bon-produit">Oui, c'est bien ce modèle</button>
          <button data-option="modifier-appareil">Non, changer d'appareil</button>
        </div>
      </div>
    </div>
  `,
  optionsGarantieHtml: `
    <div class="options-container">
      <button data-option="garantie-non">Non, je ne pense pas</button>
      <button data-option="garantie-oui">Oui, je suis couvert</button>
    </div>
  `,
  optionsTypeGarantieHtml: `
    <div class="options-container">
      <button data-option="type-garantie">Garantie Constructeur ou Extension</button>
      <button data-option="type-contratproctection">Contrat de Protection multi-appareils</button>
    </div>
    <a href="#" data-option="Guaranteehelp" class="help-link-text">
      Je ne sais pas / M'aider sur les garanties
    </a>
  `,
  repairbonusprodiyHtml: `
    <div class="options-container">
      <button data-option="type-pro">Faire aider par un réparateur</button>
      <button data-option="type-diy">Réparer moi-même (DIY)</button>
    </div>
    <a href="#" data-option="BonusHelp" class="help-link-text">
      C'est quoi le Bonus Réparation ? ℹ️
    </a>
  `,
  repairnobonusprodiyHtml: `
    <div class="options-container">
      <button data-option="type-pro">Faire aider par un réparateur</button>
      <button data-option="type-diy">Réparer moi-même (DIY)</button>
    </div>
  `,
  optionsHtml: `
    <div class="options-container">
      <button data-option="reparateur">Trouver un réparateur</button>
      <button data-option="visio">Prendre rendez-vous visio</button>
      <button data-option="diy">Réparer moi-même (DIY)</button>
    </div>
  `,
  diyResultsHtml: `
    <div class="diy-results">
      {diyResultsHtml}
    </div>
  `,  
  applianceRegisterHtml: `
  <div class="options-container">
      <button data-option="camera">Ouvrir la caméra</button>
<button data-option="invoice">Upload Facture</button>
    </div>
    <a href="#" data-option="manuel" class="help-link-text">
      Saisir manuelle ? ℹ️
    </a>
  `,
  applianceInfoHtml: `
 <div class="options-container">
      <img
        src="{productPict}"
        alt="Appareil"
        style="max-width:100px;max-height:200px;border-radius:8px;margin-right:10px;object-fit:cover;"
        onerror="this.style.display='none'"
      />
      <div>
        <strong>{productName}</strong><br />
        <strong>Marque :</strong> {productBrand}<br />
        <strong>Modèle :</strong> {productModel}
      </div>
    </div>
  
  `,

};

export default chatbotTemplates;
